import { Box } from "@mui/material";
import type { FC } from "react";
import { COVERAGE } from "../../../theme/tokens";

/** Folded-corner glyph marking a PTO-affected cell/chip. `size` is the triangle leg in px. */
export const PtoCornerFold: FC<{ size?: number }> = ({ size = 10 }) => (
	<Box
		aria-hidden
		sx={{
			position: "absolute",
			top: 0,
			right: 0,
			width: 0,
			height: 0,
			borderStyle: "solid",
			borderWidth: `0 ${size}px ${size}px 0`,
			borderColor: `transparent ${COVERAGE.PTO_MARK} transparent transparent`,
		}}
	/>
);
